<div class="tw-border-2 tw-border-white tw-rounded-2.5 tw-h-[190px] tw-w-full tw-overflow-hidden tw-mb-2 tw-relative"
     (click)="gotoProduct.emit(product())">
    <img class="tw-w-full tw-h-full tw-object-contain tw-object-center"
         alt="{{productTitle()}}"
         #image=""
         [src]="productImage()" />
    @if (isLocked()) {
        <div class="tw-absolute tw-inset-0 tw-bg-product-lock-overlay tw-backdrop-blur-[2px] tw-opacity-90 tw-flex tw-items-center tw-justify-center">
            <div class="tw-w-10 tw-h-10 tw-flex tw-items-center tw-justify-center tw-bg-gray-500 tw-rounded-full">
                <cs-icon class="tw-w-[14px] tw-h-[17px] tw-text-gray-500" [iconName]="'lock-icon-white'" />
            </div>
        </div>
    }
</div>
<div class="tw-flex tw-flex-col tw-gap-0.5 tw-mb-3">
    <p class="tw-h-9 tw-overflow-hidden tw-font-lexend tw-text-black tw-font-medium tw-text-200  tw-line-clamp-3">{{productTitle()}}</p>
    @if (!isLocked()) {
        <div class="tw-flex tw-items-center tw-gap-1 tw-font-lexend"
             (click)="gotoProduct.emit(product())">
            <p class="tw-font-medium tw-text-200 tw-text-gray-500 tw-line-through">
                ₹{{ product()?.mrp }}
            </p>
            <p class="tw-font-bold tw-text-300 tw-text-orange-500">
                ₹{{ product()?.price }}
            </p>
        </div>
    }
</div>

@if (!isLocked()) {
    @if (productQuantity() === 0) {
        <button csButton
                size="small"
                (click)="addToCart.emit({ product: product(), image })"
                class="tw-min-w-fit tw-w-fit tw-px-[26px]"
                style="margin: 0 !important;">
            <span class="tw-text-300 tw-font-medium"
                  i18n="@@add">Add</span>
        </button>
    } @else {
        <div class="tw-flex tw-w-fit tw-items-center tw-h-8 tw-text-teal-600 tw-border tw-border-teal-600 tw-rounded-2 tw-text-300 tw-font-lexend tw-font-semibold swiper-no-swiping">
            <div class="tw-flex tw-px-[11.5px]">
                <cs-icon class="tw-w-[9px] tw-h-5 tw-text-teal-600" [iconName]="'minus'" (click)="reomveFromCart.emit(product())"></cs-icon>
            </div>
            <span class="tw-px-1">{{ productQuantity() }}</span>
            <div class="tw-flex tw-px-[11.5px]">
                <cs-icon class="tw-w-[9px] tw-h-5 tw-text-teal-600" [iconName]="'plus'" (click)="addToCart.emit({ product: product(), image })"></cs-icon>
            </div>
        </div>
    }
}